import { render, staticRenderFns } from "./workshops-slider.vue?vue&type=template&id=40ce0e8f&scoped=true&"
import script from "./workshops-slider.vue?vue&type=script&lang=js&"
export * from "./workshops-slider.vue?vue&type=script&lang=js&"
import style0 from "./workshops-slider.vue?vue&type=style&index=0&id=40ce0e8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ce0e8f",
  null
  
)

export default component.exports